<template>
  <v-container fluid>
    <v-row>
      <v-col cols="4">
        <v-card
          class="mx-auto"
          tile>
          <v-list dense>
            <v-subheader>Service Health</v-subheader>
            <v-list-item-group
              color="primary">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-cellphone-text</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SMS Provider -
                     {{ providerName(HEALTH_DATA.clickSend) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Status:
                    <span class="font-weight-bold">
                       {{ providerStatus(HEALTH_DATA.clickSend) }}
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Last update:
                    <span class="font-weight-bold">
                      {{ providerLastUpdatedDate(HEALTH_DATA.clickSend) }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-email-alert</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Email Provider - {{ providerName(HEALTH_DATA.office365) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Status: <span class="font-weight-bold">
                      {{ providerStatus(HEALTH_DATA.office365) }}
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Last update:
                    <span class="font-weight-bold">
                      {{ providerLastUpdatedDate(HEALTH_DATA.office365) }}
                    </span>
                  </v-list-item-subtitle>
                  <template v-for="feature in features(HEALTH_DATA.office365)">
                    <div :key="feature.name" class="pl-4">
                      <v-list-item-subtitle>
                        Name:
                        <span class="font-weight-bold">
                          {{ feature.name }}
                        </span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Status:
                        <span class="font-weight-bold">
                          {{ feature.status }}
                        </span>
                      </v-list-item-subtitle>
                    </div>
                  </template>
                </v-list-item-content>
              </v-list-item>
               <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-cash-100</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Payments Provider</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="8">
      <ValidationObserver ref="diagnostics" v-slot="{ invalid, valid, errors }">
        <v-form v-model="diagnosticsValid">
          <v-row>
            <v-col cols="6">
              <v-menu
                v-model="dpFromDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <validation-provider
                    name="From date"
                    :rules="'required'"
                    v-slot="{errors}" slim>
                    <v-text-field
                      v-model="fmtFromDate"
                      label="From date"
                      append-icon="mdi-calendar"
                      readonly
                      :error-messages="errors"
                      v-on="on">
                    </v-text-field>
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="searchCriteria.fromDate"
                  @input="dpFromDate = false">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="6"
              sm="6">
              <v-menu
                v-model="dpToDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <validation-provider
                    name="To date"
                    :rules="'required'"
                    v-slot="{errors}" slim>
                    <v-text-field
                      v-model="fmtToDate"
                      label="To date"
                      append-icon="mdi-calendar"
                      readonly
                      :error-messages="errors"
                      v-on="on">
                    </v-text-field>
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="searchCriteria.toDate"
                  @input="dpToDate = false">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
           <v-row>
            <v-col cols="6">
              <v-select
                :items="severity"
                v-model="searchCriteria.severityLevel"
                item-text="text"
                item-value="value"
                label="Severity level"
                dense>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="maxRecords"
                v-model="searchCriteria.maxRecords"
                item-text="text"
                item-value="value"
                label="No. of Records"
                dense>
              </v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols=12>
              <v-btn
                class="ma-2 primary"
                @click="searchLogs">
                Search
                <v-icon class="ml-2">mdi-view-sequential</v-icon>
              </v-btn>
              <v-btn
                class="ma-2 secondary"
                @click="clearSearch">
                Clear
                <v-icon class="ml-2">mdi-eraser</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10">
         <v-data-table
          dense
          :headers="headers"
          :items="items"
          :hide-default-footer="true"
          class="elevation-1 diagnostics">
            <template v-slot:item.eventDate="{ item }">
              {{ $moment(item.eventDate).format(DISPLAY_LONG_DATE_FORMAT) }}
            </template>
            <template v-slot:item.message="{ item }">
              {{ item.message }}
            </template>
            <template v-slot:item.messageData="{ item }">
              <vue-json-pretty
                :deep="0"
                :showDoubleQuotes="false"
                :data="item.messageData">
              </vue-json-pretty>
            </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
/* eslint-disable camelcase */
import { required } from 'vee-validate/dist/rules';
/* eslint-enable camelcase */

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import storeConstants from '@/store/storeConstants';

setInteractionMode('eager');
extend('required', required);

export default {
  name: 'Diagnostics',
  components: {
    ValidationObserver,
    ValidationProvider,
    VueJsonPretty,
  },
  data: () => ({
    severity: [
      { value: 0, text: 'Verbose' },
      { value: 1, text: 'Information' },
      { value: 2, text: 'Warning' },
      { value: 3, text: 'Error' },
      { value: 4, text: 'Critical' }],
    maxRecords: [
      { value: 5, text: '5' },
      { value: 50, text: '50' },
      { value: 100, text: '100' },
      { value: 500, text: '500' },
    ],
    items: [],
    headers: [
      { text: 'Date', value: 'eventDate', width: 250 },
      { text: 'Message', value: 'message', width: 300 },
      { text: 'Error details', value: 'messageData', width: 400 },
    ],
    dpFromDate: false,
    dpToDate: false,
    diagnosticsValid: false,
    searchCriteria: {
      severityLevel: 3,
      fromDate: undefined,
      toDate: undefined,
      maxRecords: 5,
      bookingNumber: null,
    },
  }),
  computed: {
    ...mapGetters([
      storeConstants.DISPLAY_DATE_FORMAT,
      storeConstants.ISO_8601_FORMAT,
      storeConstants.DISPLAY_LONG_DATE_FORMAT,
      storeConstants.LOG_DATA,
      storeConstants.HEALTH_DATA,
    ]),
    fmtFromDate() {
      if (!this.searchCriteria.fromDate) {
        return null;
      }
      return this
        .$moment(this.searchCriteria.fromDate)
        .format(this.DISPLAY_DATE_FORMAT);
    },
    fmtToDate() {
      if (!this.searchCriteria.toDate) {
        return null;
      }
      return this
        .$moment(this.searchCriteria.toDate)
        .format(this.DISPLAY_DATE_FORMAT);
    },
  },
  mounted() {
    this.GET_HEALTH_DATA();
    this.searchCriteria.fromDate = this.$moment().format(this.ISO_8601_FORMAT);
    this.searchCriteria.toDate = this.$moment().add(1, 'days').format(this.ISO_8601_FORMAT);
  },
  methods: {
    ...mapActions([storeConstants.GET_LOG_DATA,
      storeConstants.GET_HEALTH_DATA,
    ]),

    providerLastUpdatedDate(item) {
      return item?.displayDateLastUpdated;
    },
    providerStatus(item) {
      return item?.status;
    },
    providerName(item) {
      return item?.serviceName;
    },
    features(item) {
      return item?.features;
    },
    searchLogs() {
      this.$refs.diagnostics.validate().then((success) => {
        this.diagnosticsValid = success;
        if (this.diagnosticsValid) {
          this.GET_LOG_DATA(this.searchCriteria)
            .then(() => {
              this.dialog = false;
              this.items = this.LOG_DATA;
            },
            (error) => {
              this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    clearSearch() {
      return null;
    },
  },
};

</script>

<style>
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 0.75rem;
  }
  .vjs-tree {
    font-size: 0.75rem;
  }
</style>
